import { Badge } from '@gitbook/spine-react';

/**
 * Badge to indicate a site item is a draft.
 */
export function DraftBadge(props: { className?: string }) {
    return <Badge label="Draft" size="xsmall" kind="outlined" className={props.className} />;
}
